import React from 'react';

import { DocumentsSections } from '@/components/documents/DocumentsSections';
import { CustomerData } from '@/sections/customerManagement/types';

interface CustomerSharingTabProps {
  customer: CustomerData;
}

export const CustomerSharingTab: React.FC<CustomerSharingTabProps> = ({
  customer,
}) => {
  return (
    <DocumentsSections
      query="home"
      customerEmail={customer.email}
      enableUpload={true}
      enableSearch={false}
      enableFavorites={false}
      isPraetorianUser={true}
    />
  );
};
